(() => {
  const cookieButton = document.querySelector('[data-ctg-cookie-preferences]');
  if (cookieButton) {
    cookieButton.addEventListener('click', async () => {
      const status = document.getElementById('CTGCookieStatus');
      cookieButton.disabled = true;
      if (status) status.textContent = '';
      try {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
          throw new Error('Privacy preferences unavailable');
        }
        await window.privacyBanner.showPreferences();
      } catch (error) {
        if (status) status.textContent = 'Le preferenze cookie non sono disponibili in questo momento. Riprova oppure contattaci a crazytcgjapan@gmail.com.';
      } finally {
        cookieButton.disabled = false;
      }
    });
  }
  const form = document.getElementById('CTGWithdrawalForm');
  if (!form) return;
  const fields = form.querySelector('[data-ctg-withdrawal-fields]');
  const summary = form.querySelector('[data-ctg-withdrawal-summary]');
  const review = form.querySelector('[data-ctg-withdrawal-review]');
  const confirm = form.querySelector('[data-ctg-withdrawal-confirm]');
  const edit = form.querySelector('[data-ctg-withdrawal-edit]');
  if (!fields || !summary || !review || !confirm || !edit) return;
  const name = form.querySelector('#CTGWithdrawalName');
  const email = form.querySelector('#CTGWithdrawalEmail');
  const order = form.querySelector('#CTGWithdrawalOrder');
  const notes = form.querySelector('#CTGWithdrawalNotes');
  const body = form.querySelector('[data-ctg-withdrawal-body]');
  let ready = false;
  review.hidden = false;
  const reset = () => {
    ready = false;
    confirm.disabled = true;
    summary.hidden = true;
    fields.hidden = false;
  };
  [name, email, order, notes].forEach(input => input.addEventListener('input', reset));
  review.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    form.querySelector('[data-ctg-review-name]').textContent = name.value.trim();
    form.querySelector('[data-ctg-review-email]').textContent = email.value.trim();
    form.querySelector('[data-ctg-review-order]').textContent = order.value.trim();
    form.querySelector('[data-ctg-review-notes]').textContent = notes.value.trim() || 'Nessuna';
    body.value = 'Comunico il recesso dal contratto per i seguenti ordini o beni: ' + order.value.trim() + '\nNome: ' + name.value.trim() + '\nEmail per la conferma: ' + email.value.trim() + '\nPrecisazioni: ' + (notes.value.trim() || 'Nessuna');
    ready = true;
    fields.hidden = true;
    summary.hidden = false;
    confirm.disabled = false;
    summary.focus();
  });
  edit.addEventListener('click', () => { reset(); name.focus(); });
  form.addEventListener('submit', event => {
    if (!ready || !form.checkValidity()) {
      event.preventDefault();
      reset();
      form.reportValidity();
      return;
    }
    body.value += '\nData e ora dichiarate dal dispositivo del cliente (da verificare dal venditore): ' + new Date().toISOString();
    confirm.disabled = true;
    confirm.textContent = 'Invio in corso…';
  });
})();
